/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @legacy
 * @alpha
 */
export class RuntimeFactoryHelper {
    get IRuntimeFactory() {
        return this;
    }
    async instantiateRuntime(context, existing) {
        const runtime = await this.preInitialize(context, existing);
        await (existing
            ? this.instantiateFromExisting(runtime)
            : this.instantiateFirstTime(runtime));
        await this.hasInitialized(runtime);
        return runtime;
    }
    async instantiateFirstTime(_runtime) { }
    async instantiateFromExisting(_runtime) { }
    async hasInitialized(_runtime) { }
}
//# sourceMappingURL=runtimeFactoryHelper.js.map